export { Iconify62 } from "./Iconify62";
